import { ToggleButtonProps } from '@procore/core-react/dist/_typedoc/ToggleButton/ToggleButton.types.json';
import * as React from 'react';
export default {
  ToggleButtonProps,
  React
};